export default {
  name    : 'Env',
  computed: {
    isStaging() {
      return import.meta.env.MODE === 'staging'
    },
    isDevelopment() {
      return import.meta.env.MODE === 'development'
    },
    isProduction() {
      return import.meta.env.MODE === 'production'
    }
  }
}
